import { render } from "./product_roadmap_coming_soon_block.vue?vue&type=template&id=3d206562"
import script from "./product_roadmap_coming_soon_block.vue?vue&type=script&lang=js"
export * from "./product_roadmap_coming_soon_block.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__